// extracted by mini-css-extract-plugin
export default {"styled-table":"Users_styled-table__I0LBX","active-row":"Users_active-row__VWMh6","statsPageContainer":"Users_statsPageContainer__t4nXC"};